export const ENROLLMENT = '/enrollment-list'
export const ENROLLMENT_PAGE = '/enrollment'
export const ENROLLMENT_PAGE_EDIT = '/enrollment-edit/:id'
